import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./Shared.css";
import "./AvailableBooks.css";

import { getAvailableBooks } from "./functions/books";

import Book from "./Book";
import ShowFavoriteBook from "./ShowFavoriteBook";

class AvailableBooks extends Component {
  constructor(props) {
    super(props);

    this.state = {availableBooks: []};
  }

  componentDidMount() {
    getAvailableBooks().then((availableBooks) => {
      this.setState({availableBooks})
    });
  }

  render() {
    const availableBooks = this.state.availableBooks.map((book) =>
      <div key={book.id} className="AvailableBook Column Center">
        <Link to={`/trade/start/${book.id}`}>
          <Book book={book} />
        </Link>
      </div>
    );

    return (
      <div>
        <h2 className="TextCenter">Now choose someone’s favorite book to read!</h2>
        <h3 className="TextCenter">Each book has been submitted by someone like you. All have handwritten forewords and many of these are the owner’s original copy!</h3>

        <div className="AvailableBooks">
          <ShowFavoriteBook clearBook={this.props.clearBook} />
          {availableBooks}
        </div>

      </div>
    );
  }
}

export default AvailableBooks;

